import {
  Calendar,
  CircleDashed,
  Mail,
  PenSquareIcon,
  RefreshCcw,
} from 'lucide-react';
import type { ComponentType } from 'react';
import { FileTextIcon } from '@/components/ui/file-text';
import {
  ACTIVITY_MARKER_SIZE_DEFAULT,
  ACTIVITY_MARKER_SIZE_STATUS,
  DOCUMENT_LIKE_ACTIVITY_EVENT_FAMILIES,
  getPurchaseOrderActivityStatusColorClass,
  isProductionDeclarationActivityEventCode,
  KEY_DATE_ACTIVITY_EVENT_CODES,
  STATUS_EVENT_FAMILY,
  SYNC_ACTIVITY_EVENT_CODE,
  UPDATE_ACTIVITY_EVENT_CODE,
} from '../config/purchase-order-activity-config';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';

export function getActivityIcon(
  activity: PurchaseOrderActivityItem,
  markerSize: number,
) {
  const IconComponent: ComponentType<{
    className?: string;
    size?: number;
  }> | null = getActivityIconComponent(activity);

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      className='shrink-0'
      size={markerSize > ACTIVITY_MARKER_SIZE_DEFAULT ? 20 : 16}
    />
  );
}

export function getActivityAccentClassName(
  activity: PurchaseOrderActivityItem,
) {
  if (activity.eventFamily === STATUS_EVENT_FAMILY) {
    return `border-transparent text-white ${getPurchaseOrderActivityStatusColorClass(activity.newValue, 'bg-gray-500')}`;
  }
  return 'border-zinc-200 bg-muted text-zinc-500';
}

export function getActivityMarkerSize(activity: PurchaseOrderActivityItem) {
  if (activity.eventFamily === STATUS_EVENT_FAMILY) {
    return ACTIVITY_MARKER_SIZE_STATUS;
  }

  return ACTIVITY_MARKER_SIZE_DEFAULT;
}

function getActivityIconComponent(activity: PurchaseOrderActivityItem) {
  if (activity.eventFamily === STATUS_EVENT_FAMILY) {
    return CircleDashed;
  }

  if (activity.eventCode === SYNC_ACTIVITY_EVENT_CODE) {
    return RefreshCcw;
  }

  if (activity.eventCode === UPDATE_ACTIVITY_EVENT_CODE) {
    return PenSquareIcon;
  }

  if (isProductionDeclarationActivityEventCode(activity.eventCode)) {
    return Mail;
  }

  if (
    DOCUMENT_LIKE_ACTIVITY_EVENT_FAMILIES.includes(
      activity.eventFamily as (typeof DOCUMENT_LIKE_ACTIVITY_EVENT_FAMILIES)[number],
    )
  ) {
    return FileTextIcon;
  }

  if (KEY_DATE_ACTIVITY_EVENT_CODES.includes(activity.eventCode)) {
    return Calendar;
  }

  return null;
}
